/**
 * What opening a sign-in page means for someone who is already signed in.
 *
 * Each sign-in page serves one kind of account (`servedRoles`). Signed in as that kind, the page has
 * nothing to offer and the person goes to their own home. Signed in as ANOTHER kind (an admin who
 * opens the customer sign-in, a customer who opens the agent one), they are switching accounts, so
 * the old session ends and the page they asked for opens. A page that names no roles is not a
 * sign-in page for anyone in particular and keeps the old behaviour.
 */
export function signInPageAction(
  servedRoles: readonly string[],
  currentRole: string | null
): 'go-home' | 'switch-account' {
  if (servedRoles.length === 0) return 'go-home'

  return currentRole !== null && servedRoles.includes(currentRole) ? 'go-home' : 'switch-account'
}
